import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const SettlementsRoute = lazy(() => import('./settlements/SettlementsRoute'));
const SettlementRoute = lazy(() => import('./settlements/SettlementRoute'));
const CashRegisterSettlementRoute = lazy(() => import('./cash-register-settlements/CashRegisterSettlementRoute'));
const SettlementImportRoute = lazy(() => import('./settlements/SettlementRoute/SettlementImportRoute'));
const CorrectionOfSettlementRoute = lazy(() => import('./settlements/SettlementRoute/CorrectionOfSettlementRoute'));
const IncomingSettlementsRoute = lazy(() => import('./incoming-settlements/IncomingSettlementsRoute'));
const IncomingSettlementRoute = lazy(() => import('./incoming-settlements/IncomingSettlementRoute'));
const IncomingSettlementImportRoute = lazy(
  () => import('./incoming-settlements/IncomingSettlementRoute/IncomingSettlementImport')
);
const CorrectionRoute = lazy(() => import('./incoming-settlements/IncomingSettlementRoute/CorrectionRoute'));
const CreateCorrectionRoute = lazy(
  () => import('./incoming-settlements/IncomingSettlementRoute/CreateCorrectionRoute')
);
const SettlementsSignOffRoute = lazy(() => import('./settlements-sign-off/SettlementsSignoffRoute'));
const IncomingAnnexesRoute = lazy(() => import('./incoming-annexes/IncomingAnnexesRoute'));
const IndividualAnnexTestRunRoute = lazy(() => import('./individual-annex-test-run/IndividualAnnexTestRunRoute'));
const ManualSettlementRoute = lazy(() => import('./manual-settlement/ManualSettlementRoute'));

export default [
  <Route
    key="settlement-sign-off"
    path="/settlement-sign-off"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <SettlementsSignOffRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="settlements"
    path="/settlements"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <SettlementsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="settlements-id"
    path="/settlements/:id"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <SettlementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="cash-register-settlements-posRef-settlement-no-externalSettlementNo"
    path="/cash-register-settlements/:posRef/settlement-no/:externalSettlementNo"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <CashRegisterSettlementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="settlements-id-correction-of-settlement"
    path="/settlements/:id/correction-of-settlement"
    element={
      <RequireAuth {...routeAccess.settlementsCreate}>
        <CorrectionOfSettlementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="manual-settlement"
    path="/manual-settlement"
    element={
      <RequireAuth {...routeAccess.settlementsCreate}>
        <ManualSettlementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="settlements-id-settlement-import"
    path="/settlements/:id/settlement-import"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <SettlementImportRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-settlements"
    path="/incoming-settlements"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <IncomingSettlementsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-settlements-id"
    path="/incoming-settlements/:id"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <IncomingSettlementRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-settlements-id-settlement-import"
    path="/incoming-settlements/:id/settlement-import"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <IncomingSettlementImportRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-settlements-id-correction-genericTransactionId"
    path="/incoming-settlements/:id/correction/new"
    element={
      <RequireAuth {...routeAccess.settlementsCreate}>
        <CreateCorrectionRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-settlements-id-correction-genericTransactionId"
    path="/incoming-settlements/:id/correction/:genericTransactionId"
    element={
      <RequireAuth {...routeAccess.settlementsEdit}>
        <CorrectionRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="annex-clearing-result-annexType-id"
    path="/annex-clearing-result"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <IndividualAnnexTestRunRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="incoming-annexes"
    path="/incoming-annexes"
    element={
      <RequireAuth {...routeAccess.settlements}>
        <IncomingAnnexesRoute />
      </RequireAuth>
    }
  />,
];
